import React, { ReactNode } from 'react';
import Modal, { Props } from 'react-modal';
import './index.scss';
import { BackIcon } from 'cokitchen-icons';
import { ReactComponent as CloseIcon } from 'assets/icons/close-icon.svg';

export type LocalModalProps = Props & {
  title?: string | ReactNode;
  titleCta?: JSX.Element;
  hasBackButton?: boolean;
  description?: string | ReactNode;
  onBackButton?: () => void;
  titleIcon?: JSX.Element;
  titleIconColor?: 'danger' | 'info' | 'success' | 'gray';
  footer?: JSX.Element;
  children?: ReactNode;
  contentClassName?: string;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: 'none',
    padding: '0px',
    overflow: 'unset'
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(3px)',
    zIndex: 10000
  }
};

export default function LocalModal({
  children,
  title,
  titleCta,
  hasBackButton,
  titleIcon,
  titleIconColor,
  description,
  onBackButton,
  footer,
  contentClassName,
  ...modalProps
}: LocalModalProps) {
  return (
    <div>
      <Modal style={customStyles} ariaHideApp={false} {...modalProps}>
        <div className={`l-modal__content relative ${contentClassName}`}>
          <div className=''>
            {title && (
              <div
                className={`${titleIcon ? 'l-modal__icons' : 'l-modal__no_icons'} pb-3 pt-4 ${
                  title && 'border-b-[0.8px] border-[#EFF0F0]'
                }`}>
                {titleIcon && (
                  <div
                    className={`l-modal__icon--wrapper 
                   l-modal__icon--${titleIconColor}`}>
                    {titleIcon}
                  </div>
                )}
                {!titleIcon && (
                  <div className='text-lg font-semibold mx-auto text-[#2E3031]'>
                    <h3>{title}</h3>
                    {titleCta}
                  </div>
                )}
              </div>
            )}
            <CloseIcon
              className='md:absolute right-[-40px] top-[-8px]'
              role='button'
              onClick={modalProps.onRequestClose}
            />
            {hasBackButton && (
              <div className='l-modal__back' role='button' onClick={onBackButton}>
                <BackIcon /> <span>Back</span>
              </div>
            )}
            {titleIcon && (
              <div className='l-modal__title'>
                <h3>{title}</h3>
                {titleCta}
              </div>
            )}
            <p className='l-modal__desc'>{description}</p>
          </div>
          <div className='l-modal__body mt-3'>{children}</div>
          {footer && <div className='l-modal__footer'>{footer}</div>}
        </div>
      </Modal>
    </div>
  );
}
